import React, { useEffect, useState } from "react";
import { Trophy } from "lucide-react";
import { api } from "@/lib/api";
import { HummingbirdIcon } from "@/components/Hummingbird";

const PERIODS = [["quarter", "Dieses Quartal"], ["year", "Dieses Jahr"], ["all", "Gesamt"]];

function Birds({ n }) {
  const shown = Math.min(n, 8);
  return (
    <span className="inline-flex items-center -space-x-1.5">
      {Array.from({ length: shown }).map((_, i) => <HummingbirdIcon key={i} size={18} flapping={false} />)}
      {n > shown && <span className="ml-2 text-[11px] text-slate-500">+{n - shown}</span>}
    </span>
  );
}

export default function HummingbirdLeaderboard() {
  const [period, setPeriod] = useState("year");
  const [rows, setRows] = useState(null);
  useEffect(() => {
    setRows(null);
    api.get("/handovers/leaderboard", { params: { period } }).then((r) => setRows(r.data.rows)).catch(() => setRows([]));
  }, [period]);
  return (
    <div className="border border-slate-200 bg-white p-6 mb-10" data-testid="hummingbird-leaderboard">
      <div className="flex flex-wrap items-center gap-3 mb-4">
        <HummingbirdIcon size={26} />
        <div className="flex-1">
          <div className="text-xs font-bold uppercase tracking-overline text-slate-500">Kolibri-Rangliste</div>
          <div className="text-sm text-slate-600">Pünktliche Übergaben an den nächsten Coach oder ins Offboarding</div>
        </div>
        <div className="flex border border-slate-200" role="tablist">
          {PERIODS.map(([k, label]) => (
            <button key={k} onClick={() => setPeriod(k)} data-testid={`leaderboard-period-${k}`}
              className={`px-3 py-1.5 text-xs transition-colors ${period === k ? "bg-slate-900 text-white" : "text-slate-600 hover:bg-slate-50"}`}>{label}</button>
          ))}
        </div>
      </div>
      {rows === null ? <div className="text-xs text-slate-400 py-4">Lädt …</div> : rows.length === 0 ? (
        <div className="text-sm text-slate-500 py-4" data-testid="leaderboard-empty">In diesem Zeitraum gab es noch keine fälligen Übergaben.</div>
      ) : (
        <div className="divide-y divide-slate-100">
          {rows.map((r, i) => (
            <div key={r.user_id} className="py-2.5 flex flex-wrap items-center gap-3 text-sm" data-testid={`leaderboard-row-${r.user_id}`}>
              <span className={`w-7 font-mono text-xs ${i === 0 ? "text-amber-600 font-bold" : "text-slate-400"}`}>{i === 0 ? <Trophy size={14} /> : `${i + 1}.`}</span>
              <span className="flex-1 min-w-[140px] text-slate-900">{r.name || "—"}</span>
              <Birds n={r.on_time} />
              <span className="font-mono text-xs text-slate-700 w-24 text-right" data-testid={`leaderboard-count-${r.user_id}`}>{r.on_time} / {r.total}</span>
              <span className={`text-[11px] px-2 py-0.5 border w-14 text-center ${r.rate >= 90 ? "bg-emerald-50 text-emerald-700 border-emerald-200" : r.rate >= 70 ? "bg-amber-50 text-amber-800 border-amber-200" : "bg-red-50 text-red-700 border-red-200"}`} data-testid={`leaderboard-rate-${r.user_id}`}>{r.rate} %</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
